module.exports = __webpack_public_path__ + "img/默认头像.773a1991.png";